import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=49c11df8&scoped=true&"
var script = {}
import style0 from "./Certification.vue?vue&type=style&index=0&id=49c11df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c11df8",
  null
  
)

export default component.exports